import 'react-phone-input-2/lib/style.css';
import './styles/App.css';
import './styles/antd.css';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { useDeviceId } from '@shared/hooks/use-deviceId';
import { config } from './lib/env-helpers';
import { useCacheBuster } from '@shared/hooks/use-cache-buster';
import { useRecaptcha } from '@shared/hooks/use-recaptcha';
import { WorkspaceProvider } from '@components/role/workspace-provider';
function App() {
  useCacheBuster();
  useDeviceId();
  useRecaptcha();

  if (config.IS_TEST_ENV) {
    loadDevMessages();
    loadErrorMessages();
  }

  return <WorkspaceProvider />;
}

export default App;
